
import React, { useState, useEffect } from 'react'
import { Checkdevice } from '../../../../components'
import { CLEARSTYLE } from '../../../../config/cssconstants'
import './ProjectgalleryFilterModalContent.css'

function ProjectgalleryFilterModalContent(props) {

    const [availablefilters, setAvailablefilters] = useState({})
    const [active, setActive] = useState(false)
    const [titles, setTitles] = useState([])
    const [keynames, setKeynames] = useState([])
    const [headerbools, setHeaderbools] = useState([])
    const [headernames, setHeadernames] = useState([])
    const device = Checkdevice()

    useEffect(() => {
        const { availablefilters, filtersetting, selectedVendorType } = props
        const { Keys, active } = availablefilters[selectedVendorType]

        var headerbools = [] // store all the boolean state of tag
        var headernames = [] // store every single tags
        var keynames = []

        for (let i = 0; i < Keys.length; i++) {
            const key = Keys[i]
            for (let j = 0; j < availablefilters[selectedVendorType][key].length; j++) {

                const { header } = availablefilters[selectedVendorType][key][j]

                let checked = false
                if (filtersetting[selectedVendorType][key].includes(header)) {
                    checked = true
                }

                if (key === 'Event Type' && header === 'Wedding & Event' && filtersetting[selectedVendorType][key].includes('Both')) {
                    checked = true

                }

                headernames.push(header)
                keynames.push(key)
                headerbools.push(checked)
            }
        }

        setKeynames([...keynames])
        setHeaderbools([...headerbools])
        setHeadernames([...headernames])
        setTitles(Keys)
        setActive(active)
        setAvailablefilters(availablefilters)

    }, [])

    const applyClick = () => {



        // var headerbools = [] // store all the boolean state of tag
        // var headernames = [] // store every single tags

        // for (let i = 0; i < Keys.length; i++) {
        //     const key = Keys[i]
        //     for (let j = 0; j < availablefilters[selectedVendorType][key].length; j++) {
        //         const { header } = availablefilters[selectedVendorType][key][j]
        //         var checked = false
        //         if (headers.length > 0) {
        //             for (let k = 0; k < headers.length; k++) {
        //                 if (headers[k] === header) { // check with user's filter if the header is already checked
        //                     checked = true
        //                 }
        //             }
        //         }
        //         headerbools.push(checked)
        //         headernames.push(header)
        //     }
        // }

        // setHeaderbools([...headerbools])
        // setHeadernames([...headernames])

        const { selectedVendorType, filtersetting } = props

        let new_filtersetting = JSON.parse(JSON.stringify(filtersetting))

        // clean filtersetting
        for (let i = 0; i < Object.keys(filtersetting[selectedVendorType]).length; i++) {
            const key = Object.keys(new_filtersetting[selectedVendorType])[i]
            new_filtersetting[selectedVendorType][key] = []
        }


        for (let i = 0; i < keynames.length; i++) {
            if (headerbools[i]) {
                let header = headernames[i]
                let key = keynames[i]
                if (headernames[i] === 'Wedding & Event') {
                    header = 'Both'
                }
                new_filtersetting[selectedVendorType][key].push(header)
            }
        }

        props.apply(new_filtersetting)
    }

    const checkboxescontent = titles.map((title, titleindex) => {

        if (props.priceorfilter === 'FILTER' && title === 'Price') { // in FILTER portal, theres no Price category
            return null
        }

        else if (props.priceorfilter === 'PRICE' && title !== 'Price') { // in PRICE portal, theres no other category other Price
            return null
        }

        return <div key={title + titleindex} className="FMC_mainbox" >
            <div className="FMC_TITLE">{title}</div>
            <div className="FMC_BOX" >
                <div className="FMC_RESETBTNBOX">
                    <button
                        key={'clear' + titleindex}
                        style={CLEARSTYLE}
                        onClick={() => {
                            let allheaderbools = headerbools.slice()
                            for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                const { header } = availablefilters[props.selectedVendorType][title][i]
                                const allheaderbool_index = headernames.indexOf(header)
                                allheaderbools[allheaderbool_index] = false
                            }
                            setHeaderbools([...allheaderbools])
                        }}
                    >
                        Reset
                    </button>
                </div>
                {availablefilters[props.selectedVendorType][title].map((item, itemindex) => {
                    const { header, type } = item
                    const boolindex = headernames.indexOf(header)

                    return <div
                        key={titleindex + title + itemindex}
                        className="FMC_cbrow"
                        onClick={() => {
                            if (type === 0) {
                                let allheaderbools = headerbools.slice()
                                allheaderbools[boolindex] = !allheaderbools[boolindex]
                                setHeaderbools([...allheaderbools])

                            }
                            else if (type === 1) {
                                let allheaderbools = headerbools.slice()
                                for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                    const { header } = availablefilters[props.selectedVendorType][title][i]
                                    if (header !== item.header) {
                                        const allheaderbool_index = headernames.indexOf(header)
                                        allheaderbools[allheaderbool_index] = false
                                    }

                                }
                                allheaderbools[boolindex] = !allheaderbools[boolindex]
                                setHeaderbools([...allheaderbools])
                            }
                        }}
                    >
                        <input
                            className="FMC_cb"
                            type="checkbox"
                            checked={headerbools[boolindex]}
                            onChange={() => {
                                if (type === 0) {
                                    let allheaderbools = headerbools.slice()
                                    allheaderbools[boolindex] = !allheaderbools[boolindex]
                                    setHeaderbools([...allheaderbools])

                                }
                                else if (type === 1) {
                                    let allheaderbools = headerbools.slice()
                                    for (let i = 0; i < availablefilters[props.selectedVendorType][title].length; i++) {
                                        const { header } = availablefilters[props.selectedVendorType][title][i]
                                        if (header !== item.header) {
                                            const allheaderbool_index = headernames.indexOf(header)
                                            allheaderbools[allheaderbool_index] = false
                                        }

                                    }
                                    allheaderbools[boolindex] = !allheaderbools[boolindex]
                                    setHeaderbools([...allheaderbools])
                                }
                            }}
                        />
                        <label className="FMC_cblbl">{header}</label>
                    </div>
                })}
            </div>
        </div>
    })

    return active
        ? <>
            <div className={"FMC_ROOT" + device} style={{ placeContent: 'space-between' }}>
                {checkboxescontent}
                {device === 'MOBILE'
                    ? <div className="FMC_APPLYBTNBOX">
                        <button
                            className='Rsvpexplorer_portalsave'
                            style={{
                                position: 'relative',
                                bottom: 0,
                                backgroundColor: '#ffffff',
                                color: 'var(--maindark)',
                                border: '1px solid var(--maindark)',
                                minHeight: 45,
                                width: '100%',
                                margin: 0
                            }}
                            onClick={applyClick}
                        >
                            Apply
                        </button>
                    </div>
                    : <div className="FMC_APPLYBTNBOX">
                        <button
                            className='Rsvpexplorer_portalsave'
                            style={{
                                position: 'relative',
                                bottom: 0,
                                backgroundColor: '#ffffff',
                                color: 'var(--maindark)',
                                border: '1px solid var(--maindark)',
                                minHeight: 45,
                                width: '100%',
                                margin: 0
                            }}
                            onClick={applyClick}
                        >
                            Apply
                        </button>
                    </div>}

            </div>
        </>
        : <div className="FMC_EMPTYROOT">
            <div className="FMC_EMPTYDIV" />
            <h4>Empty</h4>
            <div className="FMC_EMPTYDIV" />
        </div>
}
export default ProjectgalleryFilterModalContent